import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EditText from '../../../../../components/base/edit-text/edit-text';
import Button from '../../../../../components/base/button/button';
import i18n from '../../../../../translations/strings';
import { RegistrationCustomersFormStyled } from './registration-customers-form.styled';
import ClickableText from '../../../../../components/base/clickable-text/clickable-text';
import { Colors } from '../../../../../colors';
import Checkbox from '../../../../../components/base/checkbox/checkbox';
import { useSelector } from 'react-redux';

const RegistrationCustomersForm = (props: any) => {
  const {
    control,
    trigger,
    formState: { errors, submitCount },
    register,
    handleSubmit,
    setValue,
  } = useFormContext();

  const { user } = useSelector((state: any) => {
    return state.user;
  });

  useEffect(() => {
    if (user) {
      setValue('first_name', user.first_name, { shouldValidate: true });
      setValue('last_name', user.last_name, { shouldValidate: true });
      setValue('email', user.email, { shouldValidate: true });
    }
  }, [user]);

  const onFieldChangeValue = (onChange: any, value: any) => {
    onChange(value);
    if (submitCount > 0) {
      trigger();
    }
  };


  return (
    <RegistrationCustomersFormStyled.Container>
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.first_name?.message?.toString()}
            fullWidth
            {...register('first_name')}
            defaultValue={value}
            placeholder={i18n.t('registration.firstName') + '*'}
            onChange={onChange}
            label={i18n.t('registration.firstName') + '*'}
          />
        )}
        name="first_name"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.last_name?.message?.toString()}
            fullWidth
            {...register('last_name')}
            defaultValue={value}
            placeholder={i18n.t('registration.lastName') + '*'}
            onChange={onChange}
            label={i18n.t('registration.lastName') + '*'}
          />
        )}
        name="last_name"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.email?.message?.toString()}
            fullWidth
            {...register('email')}
            defaultValue={value}
            placeholder={i18n.t('common.email') + '*'}
            onChange={onChange}
            label={i18n.t('common.email') + '*'}
          />
        )}
        name="email"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.phone_number?.message?.toString()}
            fullWidth
            {...register('phone_number')}
            defaultValue={value}
            placeholder={i18n.t('registration.phoneNumber') + '*'}
            onChange={onChange}
            label={i18n.t('registration.phoneNumber') + '*'}
          />
        )}
        name="phone_number"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.vat_number?.message?.toString()}
            fullWidth
            {...register('vat_number')}
            defaultValue={value}
            placeholder={i18n.t('registration.vatNumber')}
            onChange={onChange}
            label={i18n.t('registration.vatNumber')}
          />
        )}
        name="vat_number"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.tax_code?.message?.toString()}
            fullWidth
            {...register('tax_code')}
            defaultValue={value}
            placeholder={i18n.t('registration.taxCode') + '*'}
            onChange={onChange}
            label={i18n.t('registration.taxCode') + '*'}
          />
        )}
        name="tax_code"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_name?.message?.toString()}
            fullWidth
            {...register('business_name')}
            defaultValue={value}
            placeholder={i18n.t('registration.businessName')}
            onChange={onChange}
            label={i18n.t('registration.businessName')}
          />
        )}
        name="business_name"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_address?.message?.toString()}
            fullWidth
            {...register('business_address')}
            defaultValue={value}
            placeholder={i18n.t('registration.businessAddress') + '*'}
            onChange={onChange}
            label={i18n.t('registration.businessAddress') + '*'}
          />
        )}
        name="business_address"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_email?.message?.toString()}
            fullWidth
            {...register('business_email')}
            defaultValue={value}
            placeholder={i18n.t('registration.businessEmail')}
            onChange={(value) => onFieldChangeValue(onChange, value)}
            label={i18n.t('registration.businessEmail')}
          />
        )}
        name="business_email"
      />
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_unique_code?.message?.toString()}
            fullWidth
            {...register('business_unique_code')}
            defaultValue={value}
            placeholder={i18n.t('registration.businessUniqueCode')}
            onChange={(value) => onFieldChangeValue(onChange, value)}
            label={i18n.t('registration.businessUniqueCode')}
          />
        )}
        name="business_unique_code"
      />
      <RegistrationCustomersFormStyled.Separator />
      {!user && (
        <>
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <EditText
                isPassword
                error={errors?.password?.message?.toString()}
                fullWidth
                {...register('password')}
                defaultValue={value}
                placeholder={i18n.t('common.password') + '*'}
                onChange={onChange}
                label={i18n.t('common.password') + '*'}
              />
            )}
            name="password"
          />
          <RegistrationCustomersFormStyled.Separator />
          <Controller
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <EditText
                isPassword
                error={errors?.confirm_password?.message?.toString()}
                fullWidth
                {...register('confirm_password')}
                defaultValue={value}
                placeholder={i18n.t('registration.confirmPassword') + '*'}
                onChange={onChange}
                label={i18n.t('registration.confirmPassword') + '*'}
              />
            )}
            name="confirm_password"
          />
        </>
      )}
      <RegistrationCustomersFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value = false } }) => (
          <RegistrationCustomersFormStyled.ContainerCheckbox>
            <Checkbox
              error={errors?.privacy?.message?.toString()}
              checked={value}
              onValueChange={event => onChange(event.target.checked)}
              label={{
                labelComponent: (
                  <ClickableText
                    colorText={Colors.Primary}
                    text={i18n.t('registration.accept')}
                    clickableText={i18n.t('registration.privacy') + '*'}
                    href={''}
                  />
                ),
              }}
            />
          </RegistrationCustomersFormStyled.ContainerCheckbox>
        )}
        name="privacy"
      />
      <RegistrationCustomersFormStyled.ContainerButton>
        <Button
          onClick={handleSubmit(props.onSubmit, props.onError)}
          label={i18n.t('registration.signUp')}
          disabled={props.loading}
          loading={props.loading}
        />
      </RegistrationCustomersFormStyled.ContainerButton>
    </RegistrationCustomersFormStyled.Container>
  );
};

export default RegistrationCustomersForm;
